import { OnboardingVariantType } from "../types";
import { PhotoCardBenefitsStep } from "./PhotoCardBenefitsStep";
import { PhotoCardConcernsStep } from "./PhotoCardConcernsStep";
import { PhotoCardIntroStep } from "./PhotoCardIntroStep";
import { PhotoCardNextStepsStep } from "./PhotoCardNextStepsStep";

export const allStepsWithImagesVariant: OnboardingVariantType = {
  steps: [
    { Component: PhotoCardIntroStep, footerTone: "dark" },
    { Component: PhotoCardBenefitsStep, footerTone: "dark" },
    { Component: PhotoCardConcernsStep, footerTone: "dark" },
    { Component: PhotoCardNextStepsStep, footerTone: "dark" },
  ],
};
